import React from "react";
import Modal from "../../Layout/Modal";

const ModalVideoDesc = ({
  modalId3,
  onCloseModal3,
  videoDescs,
  videoSelected,
  video_types,
  content_types,
  onAddVideoDescModal,
}) => {
  return (
    <Modal
      id={modalId3}
      title="Video Description"
      onClose={onCloseModal3}
      modalSize="modal-lg"
    >
      <div className="col-md-12">
        <div className="form-group">
          <label htmlFor="file_name">Video Name</label>
          <input
            name="file_name"
            value={
              videoDescs[videoSelected]
                ? videoDescs[videoSelected].filePath.replace(
                    "YOUTUBE_VIDEO_ID",
                    videoDescs[videoSelected].fileName
                  )
                : ""
            }
            className="form-control"
            rows={2}
            disabled={true}
          />
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label htmlFor="media_types">Video Type</label>
              {video_types.length > 0 &&
                video_types.map((item) => (
                  <div
                    key={item.code}
                    onClick={() =>
                      onAddVideoDescModal(item.code, "media_types")
                    }
                    className={
                      videoDescs[videoSelected] &&
                      videoDescs[videoSelected].media_types.indexOf(item.code) >
                        -1
                        ? "bg-orange"
                        : "bg-white"
                    }
                    style={{
                      border: "1px solid #ccc",
                      marginBottom: 5,
                      padding: 5,
                      borderRadius: 5,
                      cursor: "pointer",
                    }}
                  >
                    {item.name}
                  </div>
                ))}
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label htmlFor="content_types">Content Type</label>
              {content_types.length > 0 &&
                content_types.map((item) => (
                  <div
                    key={item.code}
                    onClick={() =>
                      onAddVideoDescModal(item.code, "content_types")
                    }
                    className={
                      videoDescs[videoSelected] &&
                      videoDescs[videoSelected].content_types.indexOf(
                        item.code
                      ) > -1
                        ? "bg-orange"
                        : "bg-white"
                    }
                    style={{
                      border: "1px solid #ccc",
                      marginBottom: 5,
                      padding: 5,
                      borderRadius: 5,
                      cursor: "pointer",
                    }}
                  >
                    {item.name}
                  </div>
                ))}
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ModalVideoDesc;
